import {Fragment} from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {ClickAwayListener, IconButton, Tooltip} from "@mui/material";
import {FormattedMessage} from "react-intl";
import {useBoolState} from "@/hooks";
import {ThirdPartyDevice} from "../types";

type Props = {
    device: ThirdPartyDevice;
};

export default ({device}: Props) => {
    const [isOpen, open, close] = useBoolState();
    const title = (
        <Fragment>
            <p style={{fontSize: "0.75rem"}}>
                <FormattedMessage id="sip_username" defaultMessage="SIP username" />: {device.sipUser}
            </p>
            <p style={{fontSize: "0.75rem"}}>
                <FormattedMessage id="sip_password" defaultMessage="SIP password" />: {device.sipPassword}
            </p>
        </Fragment>
    );

    return (
        <ClickAwayListener onClickAway={close}>
            <Tooltip
                title={title}
                placement="top"
                arrow
                disableFocusListener
                disableTouchListener
                disableHoverListener
                onClose={close}
                open={isOpen}
            >
                <span>
                    <IconButton onClick={open} size="small" color="primary">
                        <FontAwesomeIcon icon="info-circle" />
                    </IconButton>
                </span>
            </Tooltip>
        </ClickAwayListener>
    );
};
